
import { Component, Vue, Watch } from 'vue-property-decorator'
import GoodsSpecForm from '@/views/goodsManage/commodity/template/GoodsSpecForm.vue'
import GoodsSpecValueForm from '@/views/goodsManage/commodity/template/GoodsSpecValueForm.vue'
import { goodsDetailDto, goodsPackageDto, goodsSpecificationDto } from '@/api/goods'
import { guid } from '@/utils/util'
import { confirm } from '@/utils/decorator'
import { goodsSpecDelete, goodsSpecificationListEvent, goodsPackageListEvent, multiSpecEvent } from '@/constant/event'

@Component({
  components: {
    GoodsSpecForm,
    GoodsSpecValueForm
  }
})
export default class GoodsSpec extends Vue {
  $refs!: {
    goodsSpecForm: GoodsSpecForm;
    goodsSpecValueForm: GoodsSpecValueForm
  }
  goodsSpecificationList: goodsSpecificationDto[] = []
  uidList = [] // 缓存规格值数据，防止出现重复uid
  isInitData = false
  multiSpec = 0
  isSpecification = 0
  goodsPackageList: goodsPackageDto[] = []

  @Watch('goodsSpecificationList', { deep: true })
  onGoodsSpecificationList () {
    if (this.isInitData) return false
    this.isSpecification = 1
    this.$nextTick(() => {
      this.$eventBus.$emit(goodsSpecificationListEvent, this.goodsSpecificationList, this.multiSpec)
    })
  }
  @Watch('multiSpec', { immediate: true })
  onMultiSpec () {
    this.$eventBus.$emit(multiSpecEvent, this.multiSpec)
  }

  created () {
    this.$eventBus.$on(goodsPackageListEvent, (data: goodsPackageDto[]) => {
      this.goodsPackageList = data
    })
  }

  addGoodsSpec () {
    this.$refs.goodsSpecForm.showModal('add', this.getAllSpecAttrName())
  }
  editGoodsSpec (index: number, attrName: string) {
    const specIndex = this.getAllSpecAttrName().indexOf(attrName)
    let allSpecAttrName = this.getAllSpecAttrName()
    allSpecAttrName.splice(specIndex, 1)
    this.$refs.goodsSpecForm.showModal('edit', allSpecAttrName, attrName, index)
  }
  @confirm('提示', '删除规格将会清空该规格下的所有规格值，确定删除吗？', '删除')
  deleteGoodsSpec (index: number) {
    this.$eventBus.$emit(goodsSpecDelete, this.goodsSpecificationList[index].specValueList.map(item => item.attrValueCode))
    this.goodsSpecificationList.splice(index, 1)
  }
  handleEditGoodsSpec (type: string, form: { attrName: string }, index: number) {
    if (type === 'add') {
      this.goodsSpecificationList.push({
        attrName: form.attrName,
        attrSortNum: this.goodsSpecificationList.length + 1,
        specValueList: [
          {
            attrValue: '规格',
            attrValueCode: this.getUid(),
            attrValueSortNum: 1
          }
        ]
      })
    } else {
      this.goodsSpecificationList[index].attrName = form.attrName
    }
  }
  /**
   * 获取所有的规格名称
   */
  getAllSpecAttrName () {
    return this.goodsSpecificationList.map(item => item.attrName)
  }

  addGoodsSpecValue (index: number) {
    this.$refs.goodsSpecValueForm.showModal('add', index, this.getAllSpecAttrValue(index))
  }
  editGoodsSpecValue (index: number, specValueIndex: number, attrValue: string) {
    let allSpecAttrValue = this.getAllSpecAttrValue(index)
    const selfIndex = allSpecAttrValue.indexOf(attrValue)
    allSpecAttrValue.splice(selfIndex, 1)
    this.$refs.goodsSpecValueForm.showModal('edit', index, allSpecAttrValue, attrValue, specValueIndex)
  }
  deleteGoodsSpecValue (specIndex: number, index: number) {
    this.$eventBus.$emit(goodsSpecDelete, [this.goodsSpecificationList[specIndex].specValueList[index].attrValueCode])
    this.goodsSpecificationList[specIndex].specValueList.splice(index, 1)
  }
  handleEditGoodsSpecValue (type: string, specIndex: number, form: { attrValue: string }, specValueIndex: number) {
    if (type === 'add') {
      this.goodsSpecificationList[specIndex].specValueList.push({
        attrValue: form.attrValue,
        attrValueCode: this.getUid(),
        attrValueSortNum: this.goodsSpecificationList[specIndex].specValueList.length + 1
      })
    } else {
      this.goodsSpecificationList[specIndex].specValueList[specValueIndex].attrValue = form.attrValue
    }
  }
  /**
   * 获取商品规格数量
   */
  getSepcTotal () {
    let total = 0
    this.goodsSpecificationList.forEach(spec => {
      if (spec.specValueList) {
        spec.specValueList.forEach(specValue => {
          total += 1
        })
      }
    })
    return total
  }
  /**
   * 获取某一规格中所有的规格值
   */
  getAllSpecAttrValue (index: number) {
    return this.goodsSpecificationList[index].specValueList.map(item => item.attrValue)
  }
  /**
   * 获取规格值编码
   */
  getUid () {
    let uid = guid()
    let isRepeat = this.uidList.some(item => item === uid)
    if (isRepeat) {
      this.getUid()
    } else {
      (this as any).uidList.push(uid)
      return uid
    }
  }
  /**
   * 获取未删除的商品套餐列表
   */
  getNoDeleteGoodsPackageList () {
    return this.goodsPackageList.map(item => {
      if (item.packageStatus !== 3) return item
    }).filter(Boolean)
  }
  changeMultiSpec () {
    // this.multiSpec = this.multiSpec ? 0 : 1
    if (!this.multiSpec) {
      this.multiSpec = 1
      this.changeIsSpec()
    } else {
      const upGoodsPackageList = this.getNoDeleteGoodsPackageList()
      if (upGoodsPackageList.length > 1) {
        this.$dialog.alert({
          title: '提示',
          message: '请先删除部分套餐后（仅可保留一条套餐）再关闭商品规格，关闭商品规格后，已录入的规格选项会被清除'
        })
      } else {
        this.multiSpec = 0
        this.goodsSpecificationList = []
      }
    }
  }
  changeIsSpec () {
    if (this.multiSpec) {
      this.goodsSpecificationList = [this.initSpecValueList()]
      this.goodsSpecificationList[0].specValueList[0].attrValueCode = this.getUid() as string
    }
  }
  initSpecValueList () {
    return {
      attrName: '规格1',
      attrSortNum: 0,
      specValueList: [
        {
          attrValue: '规格',
          attrValueCode: this.getUid(),
          attrValueSortNum: 1
        }
      ]
    }
  }
  setData (data: goodsDetailDto) {
    this.isInitData = true
    this.goodsSpecificationList = data.goodsSpecificationList
    this.goodsPackageList = data.goodsPackageList
    this.multiSpec = data.isMultiSpec
    this.isSpecification = data.isSpecification || 0
    this.changeState()
  }
  handleSubmit () {
    return new Promise((resolve) => {
      resolve({
        goodsSpecificationList: this.goodsSpecificationList,
        multiSpec: this.multiSpec ? 1 : 0,
        isSpecification: this.isSpecification
      })
    })
  }
  changeState () {
    this.$nextTick(() => {
      this.isInitData = false
    })
  }
}
